export const nextButton: string = "nextButton";
export const backButton: string = "backButton";
export const enterEmail: string = "enterEmail";
export const enterFirstName: string = "enterFirstName";
export const enterLastName: string = "enterLastName";
export const enterDegree: string = "enterDegree";
export const enterRegiNumber: string = "enterRegiNumber";
export const enterQualifications: string = "enterQualifications";
export const changeSpeciality: string = "changeSpeciality";
export const changeCustomSpeciality: string = "changeCustomSpeciality";
export const enterPractising: string = "enterPractising";
export const enterBankName: string = "enterBankName";
export const enterBranchName: string = "enterBranchName";
export const enterAcntHolderName: string = "enterAcntHolderName";
export const enterAcntNumber: string = "enterAcntNumber";
export const common: string = "common";
export const changeTitle: string = "changeTitle";
export const changeGender: string = "changeGender";
export const changeLanguage: string = "changeLanguage";
export const changeTimeSlot: string = "changeTimeSlot";
export const changeBoardCertified: string = "changeBoardCertified";
export const changeTermsAndConditions: string = "changeTermsAndConditions";
export const changePrice: string = "changePrice";
export const changeCurrency: string = "changeCurrency";
export const changePhoneNumber: string = "changePhoneNumber";
export const changeSignatureImage: string = "changeSignatureImage";
export const changeProfileImage: string = "changeProfileImage";
export const changeNICImage: string = "changeNICImage";
export const changeSealImage: string = "changeSealImage";
export const changeSLMCCertificateImage: string = "changeSLMCCertificateImage";
export const changeSLMCIDImage: string = "changeSLMCIDImage";
export const changeProofOfQualificationImage: string = "changeProofOfQualificationImage";
export const submitForm: string = "submitForm";
export const getLanguages: string = "getLanguages";
export const setLanguages: string = "setLanguages";
export const getSpecialities: string = "getSpecialities";
export const setSpecialities: string = "setSpecialities";
export const setStatusDoctorCreate: string = "setStatusDoctorCreate";
export const setStatusError: string = "setStatusError";
export const setStatusErrorSubmit: string = "setStatusErrorSubmit";
